import volunteerFiles from './volunteerFiles';

// ===========================|| MENU ITEMS ||=========================== //

const volunteerItems = {
    items: [volunteerFiles]
};

export default volunteerItems;
